import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"home\" class=\"h40 d-flex align-items-center bg-faq section-padding mt-5 mt-md-0\"><div class=\"container\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-10\"><h1 class=\"title h1 text-shadow text-blue\">Preguntas frecuentes</h1></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "work",
  app: "app"
}
const _hoisted_3 = { class: "py-5 d-flex align-items-center" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "text-justify px-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Somos la primer plataforma en México, dedicada a ayudar al público mexicano a encontrar los cursos, talleres, carreras, diplomados, maestrías, o cualquier proceso educativo, perfecto para cada usuario, basándonos en su perfil. ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" El servicio es 100% gratuito, nunca deberás pagar anticipos, depósitos, ni cualquier otro cargo al usar ")
const _hoisted_8 = { class: "text-orange-400" }
const _hoisted_9 = { class: "text-center mt-5" }
const _hoisted_10 = { class: "text-justify px-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nuestro servicio no tiene ningún costo, es completamente gratuito. También la asesoría educativa es gratuita, y puedes solicitarla escribiéndonos cualquier duda a "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@leadgenios.com",
    target: "_blank"
  }, "info@leadgenios.com"),
  /*#__PURE__*/_createTextVNode(", nuestro equipo de trabajo te responderá en un plazo no mayor a las 72 horas. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Recuerda que nuestro servicio está disponible las 24 horas, los 365 días del año. ", -1)
const _hoisted_13 = { class: "text-center mt-5" }
const _hoisted_14 = { class: "text-justify px-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, " ¡Sí! Desde cualquier lugar dentro de México, puedes usar nuestro servicio. ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_17 = { class: "text-center mt-5" }
const _hoisted_18 = { class: "text-justify px-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " Toda la información que proporciones dentro de nuestro sitio web, así como a nuestros agentes, está protegida por la Ley de Protección de Datos. No debes de preocuparte. ", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Además, en ")
const _hoisted_21 = { class: "text-orange-400" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" únicamente trabajamos con empresas serias y reguladas, así que no debes tener miedo al utilizar nuestro servicio. ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Si tienes más preguntas, por favor escríbenos a "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@leadgenios.com",
    target: "_blank"
  }, "info@leadgenios.com"),
  /*#__PURE__*/_createTextVNode(", y uno de nuestros agentes se pondrá en contacto contigo en menos de 24 horas. ")
], -1)
const _hoisted_24 = { class: "text-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Accordion, { activeIndex: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionTab, {
                header: `¿Qué es ${_ctx.name}?`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("p", null, [
                      _hoisted_7,
                      _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.name), 1)
                    ]),
                    _createElementVNode("p", _hoisted_9, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: `¿Cuánto cuesta el servicio de ${_ctx.name}?`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("p", _hoisted_13, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: _ctx.name + ' está disponible en todo México?'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, { header: "¿Mi información está segura?" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("p", null, [
                      _hoisted_20,
                      _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.name), 1),
                      _hoisted_22
                    ]),
                    _hoisted_23,
                    _createElementVNode("p", _hoisted_24, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}